"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsService = void 0;
const config_1 = require("../config/config");
const types_1 = require("../models/draws/types");
const history_1 = require("../models/history");
const ProgressivePrize_1 = require("../models/promotion/ProgressivePrize");
const Promotion_1 = require("../models/promotion/Promotion");
const TimeUtil_1 = require("../utils/TimeUtil");
const api_1 = require("./api");
const util_1 = require("./util");
const PATH = 'promotion/api';
const PATH_V1 = 'promotion/api/v1';
const PATH_V2 = 'promotion/api/v2';
class PromotionsService {
    static async fetchGiveawayPromotions(request) {
        return this.fetchPromotions(request, types_1.PromotionType.GIVEAWAY.toString());
    }
    static async fetchSecondChancePromotions(request) {
        return this.fetchPromotions(request, types_1.PromotionType.SECOND_CHANCE.toString());
    }
    static async fetchProgressivePromotions(request) {
        return this.fetchPromotions(request, types_1.PromotionType.PROGRESSIVE.toString());
    }
    static async fetchPromotions(request, type, excludeFeatured) {
        if (!type)
            type = `${types_1.PromotionType.SECOND_CHANCE.toString()},${types_1.PromotionType.PROGRESSIVE.toString()}`;
        const { page, size, sort } = request;
        const requestParams = [`page=${page || 0}`, `size=${size || 10}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=order,desc`);
            requestParams.push(`sort=name,asc`);
        }
        if (excludeFeatured) {
            requestParams.push('excludeFeatured=true');
        }
        const url = `${PATH}/v1/promotions?promotionType.in=${type}&${requestParams.join('&')}`;
        try {
            return await (0, util_1.formatResponse)(url, request.query, Promotion_1.Promotion.JsonToEntities);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchPromotionDetails(id) {
        const url = `${PATH}/v1/promotions/${id}`;
        try {
            const response = await api_1.API.get({ url });
            return Promotion_1.Promotion.JsonToEntity(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchProgressivePrize(id) {
        const url = `${PATH}/v1/promotion/${id}/prizes`;
        try {
            const response = await api_1.API.get({ url });
            return ProgressivePrize_1.ProgressivePrize.JsonToEntity(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchActiveDraw(id) {
        const url = `${PATH}/v1/promotion/${id}/active-draw`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchActiveDraws(id) {
        const url = `${PATH}/v1/promotion/${id}/active-draws`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDraws(id) {
        const url = `${PATH}/v1/promotion/${id}/draws`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async claimFreeEntryForGuest(userData, promotionId) {
        try {
            return await api_1.API.post({
                url: `${PATH}/v2/entries/free`,
                body: userData.getPostRequest(promotionId, config_1.react_core_config.internalConfig.lotteryId)
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async claimFreeEntryForGuestNoCaptcha(userData, promotionId) {
        try {
            return await api_1.API.post({
                url: `${PATH}/v2/entries/${promotionId}/free`,
                body: userData.getPostRequest(promotionId, config_1.react_core_config.internalConfig.lotteryId)
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async claimFreeEntry(promotionId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/v2/entries/${promotionId}/free`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async countFreeEntry(drawId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/v2/entries/${drawId}/free/count`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchPrizesByDraw(drawId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/v1/draws/${drawId}/prizes`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getPrizesByDrawId(drawId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/prizes/draw/${drawId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getPrizesWithContentForDraw(drawId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/draws/${drawId}/prizes`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchPublishedDrawsByPromotion(promotion) {
        try {
            return await api_1.API.get({
                url: `${PATH}/v1/draws/published-draws/${promotion}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getDrawsforPromotionId(promotionId, page, size, sort) {
        let requestParams = `size=${size}&`;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        requestParams = sort ? `sort=${sort}&` + requestParams : `sort=draw,desc&` + requestParams;
        const url = `${PATH}/v1/promotion/${promotionId}/draws?${requestParams}`;
        try {
            const response = await api_1.API.get({
                url
            });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getPromotionFromActiveDraw(drawId) {
        const id = drawId.join(',');
        const url = `${PATH_V1}/promotions-by-draw-ids?ids=${id}`;
        try {
            return await api_1.API.get({
                url
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchSecondChanceDrawHistory(size, page) {
        try {
            const query = {
                page: page || 0,
                size: size || 10
            };
            const response = await api_1.API.get({
                url: `${PATH_V2}/entries/second-chance/history`,
                query
            });
            return {
                data: history_1.HistoryDraw.JsonToDraws(response.content),
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchActiveSecondChanceDrawForLoggedInPlayer() {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/entries/second-chance/count`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchActiveSweepstakesDrawForLoggedInPlayer() {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/entries/sweepstakes/count`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawHistoryByPromotionType(size, promotionType, page) {
        try {
            const query = {
                page: page || 0,
                size: size || 10
            };
            const response = await api_1.API.get({
                url: `${PATH_V2}/entries/second-chance/history/promotion-type/${promotionType}`,
                query
            });
            return {
                data: history_1.HistoryDraw.JsonToDraws(response.content),
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchSecondChanceDrawEntries(drawId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/entries/second-chance/${drawId}`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchPrizesWithWinners(id) {
        const url = `${PATH_V1}/draws/${id}/winners`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getAllPromotionsByDrawPaged(drawId, page, size, sort) {
        const id = drawId.join(',');
        const url = `${PATH_V1}/promotions/draw-ids?ids=${id}&size=${size || 6}&page=${page || 0}&sort=${sort || 'end,desc&sort=name,asc'}`;
        try {
            const response = await api_1.API.get({
                url
            });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchSweepStakeDraws({ page, size, sort }) {
        const requestParams = [`page=${page || 0}`, `size=${size || 9999}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=end,desc`);
            requestParams.push(`sort=name,asc`);
        }
        const url = `${PATH_V1}/draws/sweepstakes?end.lessOrEqualThan=${(0, TimeUtil_1.nowUtc)().toISOString()}&${requestParams.join('&')}`;
        try {
            const response = await api_1.API.get({ url });
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawWithAdditionalInformation(id) {
        const url = `${PATH_V1}/draws/${id}/additional-information`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getGiveawayCheckinEntries(promotionId) {
        const url = `${PATH_V1}/entry/credit/checkin/free-entries?promotionId=${promotionId}`;
        try {
            return await api_1.API.get({
                url
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getGiveawayCheckinEntriesDetail(drawId) {
        const url = `${PATH_V2}/entries/second-chance/count/by-draw/${drawId}`;
        try {
            return await api_1.API.get({
                url
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async postGiveawayCheckinEntries(requestPayload) {
        const url = `${PATH_V1}/entry/credit/checkin/free-entries`;
        try {
            return await api_1.API.post({
                url,
                body: requestPayload
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawsByPromotion(id, page, size) {
        const requestParams = [`page=${page || 0}`, `size=${size || 100}`];
        const url = `${PATH_V1}/draws?promotionId.equals=${id}&${requestParams.join('&')}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.PromotionsService = PromotionsService;
//# sourceMappingURL=promotions-service.js.map